export const CLEAN_TEXT_MODAL = 'CLEAN_TEXT_MODAL';
export const END_HOMEWORK_MODAL = 'END_HOMEWORK_MODAL';
export const NOT_LOGGED_MODAL = 'NOT_LOGGED_MODAL';
export const PAUSE_MODAL = 'PAUSE_MODAL';
export const RATING_MODAL = 'RATING_MODAL';
export const SEND_GRADE_ERROR_MODAL = 'SEND_GRADE_ERROR_MODAL';
export const REPORT_MODAL = 'REPORT_MODAL';
export const RESET_GEOGEBRA_MODAL = 'RESET_GEOGEBRA_MODAL';
export const RESUME_HOMEWORK_MODAL = 'RESUME_HOMEWORK_MODAL';
export const THEORIES_MODAL = 'THEORIES_MODAL';
export const TIME_OUT_MODAL = 'TIME_OUT_MODAL';
export const FORCED_TERMINATION_MODAL = 'FORCED_TERMINATION_MODAL';
export const GET_USER_INFO_MODAL = 'GET_USER_INFO_MODAL';
